/**
 * Registers the preload indicator directive.
 *
 * @param {object} module - The AngularJS module to register the directive with.
 */
export default function registerPreloadIndicatorDirective(module) {
    module.directive('preloadIndicator', function() {
        return {
            restrict: 'E',
            templateUrl: '/views/ib/components/preloadIndicator/PreloadIndicator.html',
            controller: 'PreloadIndicatorController',
            controllerAs: 'ctrl'
        };
    });
}
